import { Card, CardContent, Grid } from '@mui/material';
import { RslReport } from '../../api/schema';
import { SummaryTabs } from './SummaryTabs';
import { Campaign } from '@features/campaigns/subdomains/visitation/api';

export type SummaryCardProps = {
  report: RslReport;
  allReports: RslReport[];
  campaign: Pick<
    Campaign,
    'id' | 'name' | 'startDate' | 'endDate' | 'salesRequested'
  >;
};

export const SummaryCard = (props: SummaryCardProps) => {
  return (
    <Card>
      <CardContent>
        <Grid container spacing="1rem">
          <Grid size={12}>
            <SummaryTabs
              allReports={props.allReports}
              report={props.report}
              campaign={props.campaign}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
